import { createSlice, createAction, createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { ConvertTagsToHtml, ConvertHtmlToTags, TagToHtml } from "../helpers/TagHelper";

//Generators
export const injectTagAction = createAction("segments/injectTagAction");
export const generateCopySourceAction = createAction("segments/generateCopySourceAction");
export const generateAcceptSegmentAction = createAction("segments/generateAcceptSegmentAction");
export const generateAddSegmentsAction = createAction("segments/generateAddSegmentsAction");
export const generateSegmentIsOpenAction = createAction("segments/generateSegmentIsOpenAction");

const segmentsAdapter = createEntityAdapter({
  selectId: (segment) => segment.SourceId,
});

const segmentsSlice = createSlice({
  name: "segments",
  initialState: segmentsAdapter.getInitialState({
    isLoading: false,
    error: false,
  }),
  reducers: {
    segmentsIsLoading: (state) => {
      state.isLoading = true;
    },
    addSegments: (state, action) => {
      segmentsAdapter.addMany(state, action.payload);
      state.isLoading = false;
    },
    acceptTranslatedSegment: (state, action) => {
      let convertTag = TagToHtml(action.payload.text);
      segmentsAdapter.updateOne(state, { id: action.payload.id, changes: { TargetTextHtml: action.payload.text, Target: convertTag, isAccepted: true } });
    },
    segmentIsOpened: (state, action) => {
      segmentsAdapter.updateMany(state, [
        { id: action.payload.openedSegmentId, changes: { isOpened: false } },
        { id: action.payload.segmentToOpen, changes: { isOpened: true } },
      ]);
    },
    updateSegment: (state, action) => {},
  },
});

//Selectors
export const segmentsSelectors = segmentsAdapter.getSelectors((state) => state.segments);

export const segmentStateSelector = createSelector(
  (state) => state.segments,
  (segmnts) => segmnts
);

export const { segmentsIsLoading, addSegments, acceptTranslatedSegment, segmentIsOpened, updateSegment } = segmentsSlice.actions;
export default segmentsSlice.reducer;
